






























































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import copy from "copy-to-clipboard";

export default Vue.extend({
  data() {
    return {
      tableKey: 0,
      dialog: false,
      step: "form",
      valid: false,
      loading: false,
      error: "",
      copied: false,
      form: { name: "", expiresInDays: "" },
      createdToken: "",
      ruleRequired: (value) => !!value || this.$t("REQUIRED"),
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
        },
        content: {
          name: "Personal Access Tokens",
          displayFields: {
            name: {
              text: "Name",
              sortable: true,
            },
            tokenPrefix: {
              text: "Token",
              sortable: false,
            },
            expiresTime: {
              text: "Expires",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            lastUsedTime: {
              text: "Last used",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            createdTime: {
              text: "Created",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {},
          },
          template: {
            itemActionButtons: {
              delete: {},
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("personalAccessTokens", "findAll", options);
              for (const item of items) {
                if (!item.expiresTime) {
                  item.expiresTime = null;
                }
                if (!item.lastUsedTime) {
                  item.lastUsedTime = null;
                }
              }
              return [items, count];
            },
            async delete(item) {
              return await coreApiClient.call("personalAccessTokens", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            delete: {
              confirmDisplayField: "name",
            },
          },
        },
      },
    };
  },
  methods: {
    openCreateDialog() {
      this.step = "form";
      this.error = "";
      this.copied = false;
      this.form = { name: "", expiresInDays: "" };
      this.dialog = true;
    },
    async submitCreate() {
      this.error = "";
      this.loading = true;
      try {
        const result = await coreApiClient.call("personalAccessTokens", "create", undefined, {
          name: this.form.name,
          expiresInDays: this.form.expiresInDays ? +this.form.expiresInDays : undefined,
        });
        this.createdToken = result.token;
        this.step = "reveal";
      } catch (err) {
        this.error = err;
      } finally {
        this.loading = false;
      }
    },
    copyToken() {
      copy(this.createdToken);
      this.copied = true;
    },
    closeRevealAndRefresh() {
      this.dialog = false;
      this.createdToken = "";
      this.tableKey++;
    },
  },
});
